app.service('deliveryLocation',function(console, loading, deliveryShops) {
	var $container, $self, $locations, $locationInputs, $onlyAvailable, $pofficeZipCode, $toggleHours;
	var deliveryUtils, refreshCallback = false;
	var scroll = false;

	function showAvailabilty(checked) {
		if (checked) {
			$self.addClass('show-only-available');
		} else {
			$self.removeClass('show-only-available');
		}
	}
	function toogleAvailabilty() {
		showAvailabilty($onlyAvailable.prop('checked'));
	}
	function moreLocations() {
		console.log('WIĘCEJ LOKALIZACJI');
		$self.addClass('show-more-locations');
		$self.addClass('delivery-time-not-changeable');
		$self.removeClass('has-more-locations');
		$self.removeClass('show-only-selected');
		toogleAvailabilty();
	}
	function showOtherLocations() {
		$self.addClass('select-other-location');
	}
	function selectLocation($location) {
		$locations.removeClass('selected-location');
		$location.closest('.js-location').addClass('selected-location');

		deliveryUtils.selectLocation({
			city: $location.data('city'),
			shop: $location.data('shop'),
			post: $location.data('poffice'),
			machine: $location.data('machine')
		});
		if($location.data('confirm')){
			$self.addClass('show-delivery-time-message');
			$deliveryConfirm.ignore(false);
		}else{
			$self.removeClass('show-delivery-time-message');
			$deliveryConfirm.ignore(true);
		}
		$self.addClass('show-only-selected');
		if($locations.length > 1) {
			$self.addClass('has-more-locations');
		} else {
			$self.removeClass('has-more-locations');
		}
	}
	function refreshSuccess(html) {
		if(html){
			$container.html(html);
		}
		var params = {
			shopCode : false,
			cityCode : false,
			moreLocations: false,
			locations: false,
			lastLocation: false
		};
		init();
		if ($locations.length > 3) {
			params.moreLocations = true;
			$self.addClass('has-more-locations');
		}
		if ($locations.length) {
			params.locations = true;
			$self.addClass('has-locations');
		}
		if($self.find('#last-order-location').length){
			params.shopCode = $('#last-order-location').data('shop');
			params.cityCode = $('#last-order-location').data('city');
			params.lastLocation = true;
		}
		if (scroll) {
			loading.stop();
			$.scrollTo($self,200);
		} else {
			$container.removeClass('loading');
			scroll = true;
		}
		if (refreshCallback) {
			refreshCallback(params);
		}
		deliveryUtils.refreshSuccess(html);
	}
	function refresh(params) {
		if (scroll) {
			loading.start();
		} else {
			$container.addClass('loading');
		}
		deliveryUtils.refresh(params, refreshSuccess);
	}
	function selectCity(cityCode) {
		// $self.removeClass('show-delivery-time-message');
		// $deliveryConfirm.ignore(true);
		var params = deliveryUtils.selectCityParams(cityCode);
		if (params) {
			refresh(params);
		}
	}
	function searchByZipCode(zipCode) {
		if(zipCode.match(/\d{5}/)) {
			var formatZipCode = zipCode.slice(0,2) + '-' + zipCode.slice(2);
			refresh({
				latitude:'',
				cityCode: '',
				longitude:'',
				zipCode: formatZipCode
			});
		}
	}
	function setElements(option) {
		if (option) {
			switch(option.deliveryType) {
				case 'shop':
					$container = $('#shops-list');
					deliveryUtils = deliveryShops;
					break;
				case 'change-payment':
					$container = $('#shops-list');
					deliveryUtils = deliveryShops;
					break;
				/*case 'inpost':
					$container = $('#inpost');
					deliveryUtils = deliveryInpost;
					break;
				case 'poffice':
					$container = $('#poffice');
					deliveryUtils = deliveryPostOffice;*/
			}
		}
		$self = $('#location-box', $container);
		$locations = $('.js-location', $self);
		$locationInputs = $('input', $locations);
		$deliveryConfirm= $('#delivery-confirm', $self);
		$onlyAvailable = $('#only-available', $self);
		$pofficeZipCode = $('#poffice-zip-code', $self);
		$toggleHours = $('.js-toggle-hours', $self);
	}
	function setEvents() {
		$('.js-more-locations-button').on('click', function() {
			moreLocations();
		});
		$('#city-select').on('change', function() {
			selectCity($(this).val());
		});
		$onlyAvailable.on('click', function() {
			toogleAvailabilty();
		});
		$locationInputs.on('click', function() {
			selectLocation($(this));
		});
		$('.js-other-location', $self).on('click', function() {
			showOtherLocations();
		});
		$pofficeZipCode.keyfilter(/[\d\-]/);
		$pofficeZipCode.on('keyup', function() {
			var zipCode = $pofficeZipCode.val().split('-').join('');
			searchByZipCode(zipCode);
		});
		$toggleHours.on('click', function(event) {
			$(this).closest('label').toggleClass('show-hours-details');
			event.preventDefault();
		});
	}
	function init(option, callback) {
		setElements(option);
		setEvents();
		if (callback) {
			refreshCallback = callback;
		}
		if (option){
			if ( !$('#search-city').length) {
				refresh(option);
			}
		}
	}
	return {
		init:init,
		refresh:refresh
	};
});
